export default __webpack_public_path__ + "static/media/infinity-plan-hero.a6bf5e1b.png";